import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useUserAuthStore } from "./context/useUserAuthStore";
import AppHeader from "./components/AppHeader";

// --- Your pages ---
import DashboardPage from "./pages/Dashboard";
import GeofencePage from "./pages/Geofences";
import SettingsPage from "./pages/Settings";
import ReportsPage from "./pages/Reports";
import AlertsPage from "./pages/Alerts";
import LoginPage from "./pages/Login";
import TripsPage from "./pages/Trips";

import "./styles/main.css";

function App() {
  const { currentUser, checkSession, loading } = useUserAuthStore();

  // Auto-check session on mount
  useEffect(() => {
    checkSession();
  }, [checkSession]);

  // Prevent flash during check
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="loader"></div>
        <p>Loading session...</p>
      </div>
    );
  }

  return (
    <Router>
      {currentUser && <AppHeader />}

      <Routes>
        {/* Public */}
        <Route path="/login" element={!currentUser ? <LoginPage /> : <Navigate to="/dashboard" />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={currentUser ? <DashboardPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/geofences"
          element={currentUser ? <GeofencePage /> : <Navigate to="/login" />}
        />
        <Route
          path="/settings"
          element={currentUser ? <SettingsPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/trips"
          element={currentUser ? <TripsPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/reports"
          element={currentUser ? <ReportsPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/alerts"
          element={currentUser ? <AlertsPage /> : <Navigate to="/login" />}
        />

        {/* Default */}
        <Route path="*" element={<Navigate to={currentUser ? "/dashboard" : "/login"} />} />
      </Routes>
    </Router>
  );
}

export default App;
